import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as Checked } from "../../assets/analyse/Checked.svg";
import { ReactComponent as Plus } from "../../assets/analyse/Plus.svg";
import { ReactComponent as Trash } from "../../assets/analyse/Trash.svg";
import { useNavigate } from "react-router-dom";
import { ReactComponent as BackArrow } from "../../assets/navbar/BackArrow.svg";
import DropdownList from "react-widgets/DropdownList";
import ComponentLoading from "../../commonComponents/ComponentLoading";
import MainButton from "../../commonComponents/MainButton";
import { Tooltip, TooltipProps, tooltipClasses } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import { AnimatePresence, motion } from "framer-motion";
// REDUX
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { updateDocumentWeightLocal, updateDocumentDistanceLocal, updateDocumentPriceLocal, removeEntite, setEntitieCategory, setEntitieFlow } from "../../redux/actions/analysisActions";
import { fetchFlowTypeMeta, setFlowTypeMeta } from "../../redux/actions/flowActions";
import { Input } from "../../commonComponents/Inputs";

const DocumentTransportForm = (props) => {
  const flow_type_meta = useSelector((state) => (state.flow.flow_type_meta ? state.flow.flow_type_meta : null));

  const [loading, setLoading] = useState(false);

  let [flow_categories, set_flow_categories] = useState([
    // { id: 0, name: "K_Raw_Materials" },
    { id: 0, name: "K_Packaging", type_document: "Emballage", title: "d'emballage", unit: "Kg" },
    { id: 1, name: "K_Transports", type_document: "Transport", title: "de transport", unit: "Kg" },
    { id: 2, name: "K_Wastes", type_document: "Déchêt", title: "de déchêt", unit: "Kg" },
    { id: 3, name: "K_Energies", type_document: "Énergie", title: "d'énergie", unit: "kWh" },
  ]);

  // REDUX ACTIONS
  const dispatch = useDispatch();
  const updateDocumentWeightLocal_rd = (item) => dispatch(updateDocumentWeightLocal(item));
  const updateDocumentDistanceLocal_rd = (item) => dispatch(updateDocumentDistanceLocal(item));
  const updateDocumentPriceLocal_rd = (item) => dispatch(updateDocumentPriceLocal(item));
  const fetchFlowTypeMeta_rd = (item) => dispatch(fetchFlowTypeMeta(item));
  const removeEntite_rd = (item) => dispatch(removeEntite(item));
  const setEntitieCategory_rd = (item) => dispatch(setEntitieCategory(item));
  const setEntitieFlow_rd = (item) => dispatch(setEntitieFlow(item));

  // const [title, setTitle] = useState('')
  useEffect(() => {
    fetchFlowTypeMeta_rd("K_Transports");
  }, []);

  useEffect(() => {
    // console.log("reset", weight);
    console.log("22", props.entitie.weight.mentionText);
  }, [props.entitie]);

  const [flow_category, set_flow_category] = useState({ id: 1, name: "K_Transports", title: "de transport", unit: "Kg" });
  const handleChangeEntitieCategory = (e) => {
    const item = {
      ...e,
      fileName: props.fileName,
      step_index: props.step_index,
    };
    // setEntitieCategory_rd(item);
    const timeOutId = setTimeout(() => setEntitieCategory_rd(item), 1000);
    return () => clearTimeout(timeOutId);
  };

  const [flow_type, set_flow_type] = useState({ id: 1, name: "Choisir..." });
  const handleChangeEntitieFlow = (e) => {
    const item = {
      ...e,
      fileName: props.fileName,
      step_index: props.step_index,
    };
    const timeOutId = setTimeout(() => setEntitieFlow_rd(item), 1000);
    return () => clearTimeout(timeOutId);
  };

  // const [weight, setWeight] = useState(props.entitie.weight && props.entitie.weight.mentionText ? parseFloat(props.entitie.weight.mentionText.toString().replace(",", "")) : null);
  const [weight_confidence, set_weight_confidence] = useState(props.entitie.weight && props.entitie.weight.confidence ? parseFloat(props.entitie.weight.confidence).toFixed(2) * 100 + " %" : null);
  
  // const [time_out_weight, set_time_out_weight] = useState(null);
  const handleChangeWeight = async (e) => {
    const item = {
      fileName: props.fileName,
      weight: e,
      step_index: props.step_index,
    };
    console.log('setting', e)
    await updateDocumentWeightLocal_rd(item)
    // clearTimeout(time_out_weight);
    // const timeOutId = setTimeout(() => updateDocumentWeightLocal_rd(item), 1000);
    // set_time_out_weight(timeOutId);
  };

  const [price, setPrice] = useState(props.entitie.price && props.entitie.price.mentionText ? parseFloat(props.entitie.price.mentionText.toString().replace(",", "")) : null);
  const [price_confidence, set_price_confidence] = useState(props.entitie.price && props.entitie.price.confidence ? parseFloat(props.entitie.price.confidence).toFixed(2) * 100 + " %" : null);
  
  // const [time_out_price, set_time_out_price] = useState(null);
  const handleChangePrice = (e) => {
    const item = {
      fileName: props.fileName,
      price: e,
      step_index: props.step_index,
    };
    updateDocumentPriceLocal_rd(item)
    // clearTimeout(time_out_price);
    // const timeOutId = setTimeout(() => updateDocumentPriceLocal_rd(item), 1000);
    // set_time_out_price(timeOutId);
  };

  const [distance, setDistance] = useState(
    props.entitie.distance && props.entitie.distance.rows[0].elements[0].distance.text ? parseFloat(props.entitie.distance.rows[0].elements[0].distance.text.toString().replace("km", "")) : ""
  );
  const [distance_confidence, set_distance_confidance] = useState(props.entitie.distance && props.entitie.distance.rows[0].elements[0].distance.text ? "100 %" : null);
  
  const [time_out_distance, set_time_out_distance] = useState(null);
  const handleChangeDistance = (e) => {
    const item = {
      fileName: props.fileName,
      distance: e,
      step_index: props.step_index,
    };
    updateDocumentDistanceLocal_rd(item)
    // clearTimeout(time_out_distance);
    // const timeOutId = setTimeout(() => updateDocumentDistanceLocal_rd(item), 1000);
    // set_time_out_distance(timeOutId);
  };

  const InputError = ({ message }) => {
    return (
      <motion.p className="flex items-center gap-1 px-2 text-xs font-semibold text-red-500 bg-red-100 rounded-md">
        {/* <MdError /> */}
        {message}
      </motion.p>
    );
  };

  return (
    <>
      <div className={(props.hiddenindex > 0 ? "pt-[10px]" : "") + " flex flex-row items-center justify-between"}>
        <div className="flex flex-row items-center">
          <button
            className="flex items-center"
            onClick={() => {
              let newhidden = [...props.hidden];
              newhidden[props.hiddenindex] = !newhidden[props.hiddenindex];
              props.setHidden(newhidden);
              console.log(props.hidden);
            }}
          >
            <div className="flex flex-col ml-[-3px] mr-[10px] bg-[#F3F5F7] rounded-xl h-[20px] w-[20px] justify-center items-center">
              <BackArrow transform={`rotate(${180 + 90 * (props.hidden[props.hiddenindex] ? props.hidden[props.hiddenindex] : 0)})`} height={10} />
            </div>
          </button>
          <p className="font-Poppins-SemiBold">{"Entitée " + (props.hiddenindex + 1)}</p>
        </div>
        <button
          onClick={async () => {
            await removeEntite_rd({ fileName: props.fileName, index: props.index, step_index: props.step_index });
          }}
        >
          <Trash height={15} />
        </button>
      </div>

      {props.hidden[props.hiddenindex] ? (
        <div className="flex flex-col h-min space-y-[10px]">
          <div className="flex w-[300px] flex-col space-y-[10px] ">
            <p className="font-Poppins-SemiBold">{"Type de document*"}</p>

            <DropdownList
              className="h-[40px] w-[340px] bg-[#F3F5F7]"
              style={{ fontSize: 14 }}
              data={flow_categories}
              dataKey="id"
              textField="type_document"
              value={flow_category}
              onChange={async (value) => {
                setLoading(true);
                set_flow_category(value);
                handleChangeEntitieCategory(value);
                // handleChangeEntitieCategory(value);
                await set_flow_type({ id: 1, name: "Choisir..." });
                await fetchFlowTypeMeta_rd(value.name);
                setLoading(false);
              }}
            />
          </div>


          <div className="flex w-[300px] flex-col space-y-[10px] mb-[10px]">
            <div className="flex flex-row items-center justify-between pr-[10px]">
              <p className="font-Poppins-SemiBold">{"Type " + flow_category.title + "*"}</p>
              <div>{props.flow_type_error && <InputError message={props.flow_type_error} />}</div>
            </div>
            <DropdownList
              filter={"contains"}
              style={{ fontSize: 14 }}
              // value={x.flow.name_fr ? x.flow.name_fr : null}
              // value={"Choisir"}
              className="bg-[#F3F5F7]"
              data={flow_type_meta ? flow_type_meta : []}
              textField={"name"}
              dataKey={"id"}
              onChange={async (event) => {
                // setLoading(true);
                // await handleChangeIngredientTransport(event, x, i, current.origin);
                await set_flow_type(event);
                handleChangeEntitieFlow(event);
                props.set_flow_type_error(null);
                // setLoading(false);
              }}
              renderValue={({ item }) => (
                <Tooltip title={flow_type.name} arrow>
                  <p>{flow_type.name}</p>
                </Tooltip>
                // <Tooltip title={item.flow.name_fr} arrow>
                //   <p>{item.flow.name_fr}</p>
                // </Tooltip>
              )}
            />
          </div>

          <div className="h-full flex flex-col relative space-y-[10px]">
            <div className="flex flex-row items-center justify-between pr-[10px]">
              <div className="flex flex-row items-center">
                <p className="font-Poppins-SemiBold">{"Quantité"}</p>
                <p className="ml-[4px] font-Poppins-Light text-sm">{" (" + flow_category.unit + ")*"}</p>
              </div>
              <div>{props.weight_error && <InputError message={props.weight_error} />}</div>
            </div>
            <div className="flex flex-row w-[300px] items-center">
              <span className="pointer-events-none absolute ml-[250px]">{weight_confidence}</span>
              <input
                // value={weight}
                value={props.entitie.weight && props.entitie.weight.mentionText ? parseFloat(props.entitie.weight.mentionText.toString().replace(",", "")) : null}
                onChange={async (e) => {
                  // setWeight(e.target.value);
                  await handleChangeWeight(e.target.value);
                  set_weight_confidence(null);
                  if (!e.target.value) {
                    props.set_weight_error("Valeur incorrecte");
                  } else {
                    props.set_weight_error(null);
                  }
                }}
                placeholder={"Poids"}
                type={"number"}
                className={"w-[300px] bg-[#F3F5F7] h-[35px] rounded-lg pl-[10px] text-xs font-Poppins-Regular"}
              />
            </div>
          </div>

          {flow_category.name === "K_Transports" && (
            <div className="h-full flex flex-col relative space-y-[10px]">
              <div className="flex flex-row items-center justify-between pr-[10px]">
                <div className="flex flex-row items-center">
                  <p className="font-Poppins-SemiBold">{"Distance"}</p>
                  <p className="ml-[4px] font-Poppins-Light text-sm">{"(Km)*"}</p>
                </div>
                <div>{props.distance_error && <InputError message={props.distance_error} />}</div>
              </div>

              <div className="flex flex-row w-[300px] items-center">
                <span className="pointer-events-none absolute ml-[250px]">{distance_confidence}</span>
                <input
                  // value={distance}
                  value={props.entitie.distance && props.entitie.distance.rows[0].elements[0].distance.text ? parseFloat(props.entitie.distance.rows[0].elements[0].distance.text.toString().replace("km", "")) : ""}
                  onChange={(e) => {
                    // setDistance(e.target.value);
                    handleChangeDistance(e.target.value);
                    set_distance_confidance(null);
                    if (!e.target.value) {
                      props.set_distance_error("Valeur incorrecte");
                    } else {
                      props.set_distance_error(null);
                    }
                  }}
                  placeholder={"Distance"}
                  type={"number"}
                  className={"w-[300px] bg-[#F3F5F7] h-[35px] rounded-lg pl-[10px] text-xs font-Poppins-Regular"}
                />
              </div>
            </div>
          )}

          <div className="h-full flex flex-col relative space-y-[10px]">
            <div className="flex flex-row items-center justify-between pr-[10px]">
              <div className="flex flex-row items-center">
                <p className="font-Poppins-SemiBold">{"Prix"}</p>
                <p className="ml-[4px] font-Poppins-Light text-sm">{"(€)*"}</p>
              </div>
              <div>{props.price_error && <InputError message={props.price_error} />}</div>
            </div>

            <div className="flex flex-row w-[300px] items-center">
              <span className="pointer-events-none absolute ml-[250px]">{price_confidence}</span>
              <input
                // value={price}
                value={props.entitie.price && props.entitie.price.mentionText ? parseFloat(props.entitie.price.mentionText.toString().replace(",", "")) : null}
                onChange={async (e) => {
                  // setPrice(e.target.value);
                  console.log("value", e);
                  await handleChangePrice(e.target.value);
                  set_price_confidence(null);
                  if (!e.target.value) {
                    props.set_price_error("Valeur incorrecte");
                  } else {
                    props.set_price_error(null);
                  }
                }}
                placeholder={"Prix"}
                type={"number"}
                className={"w-[300px] bg-[#F3F5F7] h-[35px] rounded-lg pl-[10px] text-xs font-Poppins-Regular"}
              />
            </div>
          </div>
        </div>
      ) : (
        <> </>
      )}
    </>
  );
};

export default DocumentTransportForm;
